import useSWR from 'swr';
import fetcher from 'lib/fetcher';
import { useDebounce } from 'usehooks-ts';

export type APIApartmentSellInfoRes = {
  id: number;
  price: number;
  floor: number;
  floorCount: number;
  roomCount: number;
  areaInSqM: number;
  ceilingHeight: number;
  apartmentComplexTitle: string;
  planImage: string | null;
  loweredPrice: number;
  hasMaternityCapital: boolean;
  hasBurden: boolean;
  minorOwners?: boolean;
  typeId?: number;
};

const useApartmentSaleInfo = (buildingId: number, apartmentNumber: string) => {
  const debouncedApartmentNumber = useDebounce(apartmentNumber);

  const { data, error, isLoading } = useSWR(
    debouncedApartmentNumber ? [buildingId, debouncedApartmentNumber] : null,
    ([buildingId, apartmentNumber]) =>
      fetcher.swr<APIApartmentSellInfoRes>('/facilities/sale-info', {
        params: { buildingId, apartmentNumber },
      }),
    { revalidateOnFocus: false },
  );

  return { apartmentSellInfo: data, error, isLoading };
};

export default useApartmentSaleInfo;
